import { ValidationErrors, ValidationResult } from "@/libs/base/models/validation";
import { ZodError, ZodSchema } from "zod";

export default class ValidationUtils {
  /**
   * Validates the given data against the given validation schema using Zod.
   */
  static validate<T>(validationSchema: ZodSchema<T>, data: T): ValidationResult<T> {
    const result = validationSchema.safeParse(data);
    if (result.success) {
      return { data: result.data };
    }

    const errors = this.createValidationErrors(result.error);
    return { errors };
  }

  private static createValidationErrors(validationError: ZodError): ValidationErrors {
    const validationResult: ValidationErrors = {};
    validationError.errors.forEach((error) => {
      if (error.path) {
        if (!validationResult[error.path.toString()]) {
          validationResult[error.path.toString()] = [];
        }
        validationResult[error.path.toString()].push(error.message);
      }
    });

    return validationResult;
  }
}
